import AppContext, { useZxContext } from './zxContext';
import './App.scss'

function App() {
  return (
    <AppContext />
  )
}

export default App;
